import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {QueryClientProvider,QueryClient} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {QueryLoadingBoundary} from './components/index';
import { Toaster } from 'react-hot-toast';
import { ScrollToTop } from './components/shared/index';

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
   <QueryLoadingBoundary>

   <ReactQueryDevtools initialIsOpen={true}/> 
      <BrowserRouter>
      <ScrollToTop/>
         <Toaster
         position="bottom-center"
         reverseOrder={false}
         />
         <App />
      </BrowserRouter>
   </QueryLoadingBoundary>
   </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();